// App.vue file

<template>
  <div id="app">
    <cookies />
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Cookies from "./components/cookiesChoices.vue";

export default {
  name: "App",
  components: {
    Cookies
  }
};
</script>

<style>
/* GENERAL */
@font-face {
  font-family: Montserrat;
  src: url("./assets/fonts/Montserrat-Regular.ttf");
}
@font-face {
  font-family: Montserrat-SemiBold;
  src: url("./assets/fonts/Montserrat-SemiBold.ttf");
}
.fade-enter-active,
.face-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
body,
textarea {
  font-family: Montserrat;
}
.container {
  margin: 2rem;
}
.page {
  width: 80%;
  margin: auto;
}
.ban {
  height: 20px;
  width: 100%;
  background-color: rgba(173, 17, 30, 0.85);
}

/* FIL D'ARIANE */
.breadcrumb ul {
  display: flex;
}
.breadcrumb li {
  margin-left: 6px;
  list-style-type: none;
}
.breadcrumb li::before {
  content: ">";
}
.breadcrumb li:first-child::before {
  content: " ";
}
.breadcrumb li a {
  color: black;
  font-family: Montserrat-SemiBold;
}
.breadcrumb li a:hover {
  color: rgb(173, 17, 30);
}
span.current-page {
  margin-left: 6px;
}

@media all and (max-width: 1000px) {
  .page {
    width: 100%;
  }
}

@media all and (max-width: 760px) {
  .breadcrumb {
    font-size: 0.8rem;
  }
}
@media all and (max-width: 600px) {
  .breadcrumb {
    font-size: 0.6rem;
  }
}
@media all and (max-width: 440px) {
  .breadcrumb ul {
    display: flex;
    flex-direction: column;
  }
  li.real_page {
    margin-left: 10px;
  }
  .breadcrumb li {
    margin-bottom: 2%;
  }
}
</style>
